import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'lib-pagination-new',
  standalone: false,
  templateUrl: './pagination-new.component.html',
  styleUrl: './pagination-new.component.scss'
})
export class PaginationNewComponent implements OnChanges {
  @Input() totalItems: number = 0;
  @Input() pageSize: number = 0;
  @Input() currentPage: number = 1;
  @Input() pageSizes: number[] = [];
  @Input() showCustomDropdown: boolean = true;

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  
  constructor(private eRef: ElementRef) {}
@ViewChild('dropdownWrapper', { static: false }) wrapper!: ElementRef;
  totalPages: number = 0;
  totalPagesArr: number[] = [];
  startIndex: number = 0;
  endIndex: number = 0;

  dropdownOpen = false;

  ngOnChanges() {
    this.calculatePagination();
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectPageSize(size: number, event: Event) {
    event.stopPropagation();
    this.pageSize = size;
    this.dropdownOpen = false;
    this.updatePagedData();
  }

  calculatePagination() {
  this.totalPages = Math.ceil(this.totalItems / this.pageSize);

  // Calculate start/end window for 5 buttons
  let start = this.currentPage - 2;
  let end = this.currentPage + 2;

  if (start < 1) {
    end += 1 - start;
    start = 1;
  }

  if (end > this.totalPages) {
    start -= end - this.totalPages;
    end = this.totalPages;
  }

  start = Math.max(start, 1);
  end = Math.min(end, this.totalPages);

  this.totalPagesArr = Array.from(
    { length: end - start + 1 },
    (_, i) => start + i
  );

  this.startIndex = (this.currentPage - 1) * this.pageSize;
  this.endIndex = Math.min(this.startIndex + this.pageSize, this.totalItems);
}


  updatePagedData() {
    this.currentPage = 1;
    this.pageSizeChange.emit(this.pageSize);
    this.pageChange.emit(this.currentPage);
    this.calculatePagination();
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.pageChange.emit(this.currentPage);
    this.calculatePagination();
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChange.emit(this.currentPage);
      this.calculatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.pageChange.emit(this.currentPage);
      this.calculatePagination();
    }
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.eRef.nativeElement.querySelector('.custom-dropdown')?.contains(event.target as Node)) {
      this.dropdownOpen = false;
    }
  }
}